import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GoogleFormsService } from 'src/app/services/google-forms.service';

enum ReferralState {
  FORM = 0,
  RESPONSE = 1,
}

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss']
})
export class ReferralComponent {
  state: ReferralState = ReferralState.FORM;
  
  referral: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
  });

  constructor(private googleFormsService: GoogleFormsService ) {}

  onFormSubmit() {
    const v = this.referral.value;
    this.googleFormsService.postReferralToForms(v.name, v.phone, v.email).subscribe(() => {});
    this.state = ReferralState.RESPONSE;
  }

}
